import PropTypes from 'prop-types'
import { WhatNextInitial } from './whatNextInitial'
import { useLanguageContext } from '../../context/locale.context'
import { WhatNextProgressToNext } from './whatNextProgressToNext'
import { WhatNextDelegate } from './whatNextDelegate'
import { useState } from 'react'
import { WhatNextDeclined } from './whatNextDeclined'
import { WhatNextCancelRequest } from './whatNextCancelRequest'

const WhatNext = ({ scrollDown }) => {
	const [viewType, setViewType] = useState(null)

	const {
		state: { locale },
	} = useLanguageContext()

	const onCloseDecline = () => {
		setViewType(null)
	}
	const onCloseCancelRequest = () => {
		setViewType(null)
	}

	const showDelegateScreen = () => {
		setViewType('DELEGATE')
		scrollDown()
	}

	const showProgressToNext = () => {
		setViewType('PROGRESS_TO_NEXT')
		scrollDown()
	}

	const roleWiseButtons = {
		lead: [
			{
				label: locale['Progress to next status'],
				action: () => {
					showProgressToNext()
				},
			},
			{
				label: locale['Cancel Request'],
				action: () => {
					setViewType('CANCEL_REQUEST')
				},
			},
		],
		creator: [
			{
				label: locale['Show Decline History'],
				action: () => setViewType('DECLINED_HISTORY'),
			},
			{
				label: locale['Cancel Request'],
				action: () => {
					setViewType('CANCEL_REQUEST')
				},
			},
			{
				label: locale['Delegate'],
				action: () => {
					showDelegateScreen()
				},
			},
			{
				label: locale['I Will Do It'],
				action: () => {
					showProgressToNext()
				},
			},
		],
	}

	const getWhatNextView = () => {
		if (viewType)
			switch (viewType) {
				case 'PROGRESS_TO_NEXT':
					return <WhatNextProgressToNext />
				case 'DELEGATE':
					return <WhatNextDelegate />
				case 'DECLINED_HISTORY':
					return (
						<WhatNextDeclined
							onClose={onCloseDecline}
							onChooseLead={showDelegateScreen}
						/>
					)
				case 'CANCEL_REQUEST':
					return <WhatNextCancelRequest onClose={onCloseCancelRequest} />
				default:
					return null
			}
	}

	return (
		<>
			<WhatNextInitial roleWiseButtons={roleWiseButtons} />
			{getWhatNextView()}
		</>
	)
}

WhatNext.propTypes = {
	scrollDown: PropTypes.func.isRequired,
}

export { WhatNext }
